// @ts-strict-ignore
import React from 'react'
import { Dialog } from '../ui/dialog'
import { groupItems } from '../../util/promotions'
import { PromotionAdGroupLinker, SearchResultRow } from './PromotionAdGroupLinker'

interface ItemAddDialog {
    showAdd: boolean
    setShowAdd: any // @todo type
    items: any[] // @todo type
    setItems: any // @todo type
    onUnlink?: (item: any) => void
}

export const PromotionItemAddDialog = ({
    showAdd,
    setShowAdd,
    items,
    setItems,
    onUnlink = (item: any) =>
        setItems((prev: any[]) =>
            prev.filter(
                (i) => !(i.campaign_id == item.campaign_id && i.ad_group_id == item.ad_group_id),
            ),
        ),
}: ItemAddDialog) => {
    return (
        <Dialog
            isOpen={showAdd}
            onClose={() => setShowAdd(false)}
            className="p-0 dialog-promotion"
            style={{ width: '960px', maxWidth: '95vw', borderRadius: '16px' }}
            zIndex={40}
        >
            <PromotionAdGroupLinker
                items={items}
                onLink={(row: SearchResultRow) => {
                    // Don't re-add if already linked
                    if (
                        items.some(
                            (i) =>
                                i.campaign_id == row.campaign_id &&
                                i.ad_group_id == row.ad_group_id,
                        )
                    )
                        return
                    const newItem = {
                        ...row,
                        use_search_terms: false,
                        promotion_broad: false,
                        promotion_phrase: false,
                        promotion_exact: false,
                        promotion_products: false,
                        negation_phrase: false,
                        negation_exact: false,
                        negation_products: false,
                    }
                    setItems((prev: any[]) => groupItems([...prev, newItem]))
                }}
                onUnlink={onUnlink}
                onClose={() => setShowAdd(false)}
            />
        </Dialog>
    )
}
